import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import { FALLBACK_SYSTEM_INFO, loadSystemInfo, readCachedSystemInfo } from '@/utils/system-info'

Vue.use(Vuex)

function readStoredAdminInfo() {
  try {
    const raw = localStorage.getItem('adminInfo')
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export default new Vuex.Store({
  state: {
    // 直接以本地缓存初始化：刷新页面时侧边栏不会先空一下再弹出来
    adminInfo: readStoredAdminInfo(),
    // 系统名 / logo 来自 system_configs（分组 system），缓存优先，避免刷新时闪一下旧值
    systemInfo: readCachedSystemInfo() || { ...FALLBACK_SYSTEM_INFO },
    sidebar: {
      opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true
    }
  },
  getters: {
    adminInfo: state => state.adminInfo,
    sidebar: state => state.sidebar,

    /** 系统信息（系统名 / 说明 / logo / 版本号），由 system_configs 下发 */
    systemInfo: state => state.systemInfo,
    systemName: state => state.systemInfo.name,
    /** 原始值，可能是空串；展示前请过 resolveLogo() */
    systemLogo: state => state.systemInfo.logo,

    /** 当前角色可见的菜单 key（与路由 path 一致），由服务端下发 */
    menus: state => (state.adminInfo && state.adminInfo.menus) || [],

    /** 是否超管 */
    isSuperAdmin: state => !!(state.adminInfo && state.adminInfo.superAdmin),

    /** 角色中文名 */
    roleLabel: state => (state.adminInfo && state.adminInfo.roleLabel) || '',

    /**
     * 可管理的学校 [{ id, name }]
     * 服务端下发的是 schoolIds / schoolNames 两个平行数组，这里合并成对象数组给下拉框用。
     */
    schoolOptions: state => {
      const info = state.adminInfo
      if (!info || !info.schoolIds) {
        return []
      }
      const names = info.schoolNames || []
      return info.schoolIds.map((id, index) => ({
        id,
        name: names[index] || ('学校#' + id)
      }))
    },

    /** 是否只管辖单个学校（决定学校筛选器是"下拉"还是"直接写死"） */
    lockedToSingleSchool: state => {
      const info = state.adminInfo
      return !!(info && !info.superAdmin && info.schoolIds && info.schoolIds.length === 1)
    }
  },
  mutations: {
    SET_ADMIN_INFO: (state, adminInfo) => {
      state.adminInfo = adminInfo
    },
    SET_SYSTEM_INFO: (state, systemInfo) => {
      state.systemInfo = systemInfo
    },
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
    }
  },
  actions: {
    setAdminInfo({ commit }, adminInfo) {
      commit('SET_ADMIN_INFO', adminInfo)
      if (adminInfo) {
        localStorage.setItem('adminInfo', JSON.stringify(adminInfo))
      } else {
        localStorage.removeItem('adminInfo')
      }
    },
    /**
     * 拉取系统名 / logo 等系统信息
     * 登录页（未登录）与登录后的布局都会调；失败时 loadSystemInfo 内部已兜底，
     * 不会 reject，所以这里不需要 catch。
     */
    loadSystemInfo({ commit }) {
      return loadSystemInfo().then(info => {
        commit('SET_SYSTEM_INFO', info)
        return info
      })
    },
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    logout({ commit }) {
      return new Promise(resolve => {
        Cookies.remove('admin_token')
        localStorage.removeItem('adminInfo')
        commit('SET_ADMIN_INFO', null)
        resolve()
      })
    }
  }
})
